import { DemoDataSchema, type DemoData } from '@pointfive/contracts';
import { coreData } from './core';
import { execData } from './exec';
import { reviewData } from './review';
import { journalData } from './journal';
import { aiData } from './ai';
import { scoreData } from './score';
import { digestData } from './digest';
import { compareData } from './compare';
import { analyticsData } from './analytics';
import { progressData } from './progress';
import { eodData } from './eod';
import { styleData } from './style';
import { dashboardData } from './dashboard';

export const DEMO_AS_OF = '2026-07-24T08:40:00Z'; // the reference's "present" (Friday, July 24 2026)

/** Builds the deterministic demo dataset. `seed` is recorded for provenance; the reference data is fixed by construction. */
export function buildDemoData(seed = 'pointfive-demo-2026'): DemoData {
  const data: DemoData = {
    meta: { seed, mode: 'simulated', asOf: DEMO_AS_OF, degraded: [] },
    core: coreData,
    exec: execData,
    review: reviewData,
    journal: journalData,
    ai: aiData,
    score: scoreData,
    digest: digestData,
    compare: compareData,
    analytics: analyticsData,
    progress: progressData,
    eod: eodData,
    style: styleData,
    dashboard: dashboardData,
  };
  return DemoDataSchema.parse(data);
}
